/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['midn.', 'på morg.', 'på förm.', 'på efterm.', 'på kvällen', 'på natten'],
    ['midnatt', 'på morg.', 'på förm.', 'på efterm.', 'på kvällen', 'på natten'],
    [
      'midnatt', 'på morgonen', 'på förmiddagen', 'på eftermiddagen', 'på kvällen',
      'på natten'
    ]
  ],
  [
    ['midn.', 'morg.', 'förm.', 'efterm.', 'kväll', 'natt'],
    ['midnatt', 'morgon', 'förm.', 'efterm.', 'kväll', 'natt'],
    ['midnatt', 'morgon', 'förmiddag', 'eftermiddag', 'kväll', 'natt']
  ],
  [
    '00:00', ['05:00', '10:00'], ['10:00', '12:00'], ['12:00', '18:00'], ['18:00', '24:00'],
    ['00:00', '05:00']
  ]
];
